import React, { useEffect, useState, useRef, useCallback , useLayoutEffect} from "react";
import validIcon from "../../assets/images/register/green_check.svg";
import { getLocationField } from "../../../store/slices/Registration/SignUpSlices";
import { connect } from "react-redux";
import { BiCurrentLocation } from "react-icons/bi";
import CommonModal from "../utils/commonModal";
import Cookies from "universal-cookie";
import { createCurrentUrl, getAbsoluteDestinationUrl, certificationPage, deviceType} from "../../utils/registrationUtils";
import Loading from "../utils/loader";
import LocationData from "./LocationData.json";
import {Prefill_Fields} from "../../constants/registration";

const CareersRegisterInputLocation = (props) => {
  const { values, name, setFieldValue, errors, touched, handleBlur } = props;
  
  const dropdownRef = useRef(null);
  const [focused, setFocused] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [data, setData] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debounceState, setDebounceState] = useState(false);
  const [show, setShow] = useState(false);
  const [locationList, setLocationList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [read, setReadOnly] = useState(true);
  const cookies = new Cookies();
  const observer = useRef();
  //to check correct current url
  const subDomainName = window.location.host?.split(".")[0];
    const urlCheck = window.location.href;
    let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
     window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
    const currentUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
    const sourseDestination = currentUrl ? `${currentUrl}${window.location.search}` : getAbsoluteDestinationUrl();
    let signupUrl = window.location.pathname?.includes("/user/register");
    let completeProfileUrl = window.location.pathname?.includes("/user/complete-profile");
  const [focussedOption, setFocussedOption] = useState(-1)
  //-----------------------------
  useLayoutEffect(() => {
    const locationData = [];
      for (const itm in LocationData?.data?.values) {
        if (itm !== "locations" && pageNumber == 1 && !searchQuery) {
          if (LocationData?.data?.values?.[itm]?.length > 0) {
            locationData.push({
              label: itm,
              options: LocationData?.data?.values?.[itm]?.map(
                (item, index) => ({
                  id: item.location_id,
                  label: item.city_name,
                  state_id: item.state_id,
                })
              ),
            });
          }
        }
      }
      setData(locationData);
  }, [])
  useEffect(() => {
    if (props.geolocationData) {
      getLocaltionFieldApi();
    }
    // to close the dropDown
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target) && showDropdown ) {
        setShowDropdown(false);
          setFocused(false);
          handleBlur({
            target: { name: "location" },
          });
        setReadOnly(true);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props.geolocationData,showDropdown]);

  const getLocaltionFieldApi = () => {
    let params = {};
    params.current_url = sourseDestination || createCurrentUrl();
    params.current_location = props.geolocationData?.city ? `${props.geolocationData?.city},${props.geolocationData?.state},${props.geolocationData?.country}` : "";
    params.field = "location";
    // params.q = searchQuery;
    params.page_size = 20;
    params.page_number = 1;
    params.certification = props.domain?.id == 2 ? "True" : "False";
    props.dispatch(getLocationField(params));
  };
  useEffect(() => {
    if (props.locationFieldData?.values) {
      const locationData = [];
      for (const itm in props.locationFieldData?.values) {
        if (itm !== "locations" && pageNumber == 1 && !searchQuery) {
          if (props.locationFieldData?.values?.[itm]?.length > 0) {
            locationData.push({
              label: itm,
              options: props.locationFieldData?.values?.[itm]?.map(
                (item, index) => ({
                  id: item.location_id,
                  label: item.city_name,
                  state_id: item.state_id,
                })
              ),
            });
          }
        }
      }
      if (props.locationFieldData?.values?.locations) {
        for (const state in props.locationFieldData?.values?.locations) {
          const stateData = props.locationFieldData?.values?.locations[state];
          locationData.push({
            label: state,
            options: stateData?.map((item, index) => ({
              id: item.location_id,
              label: item.city_name,
              state_id: item.state_id,
            })),
          });
        }
      }
      setData(locationData);
    }
  }, [props.locationFieldData]);

  useEffect(() => {
    if (data?.length > 0) {
      // Done for prefilling values in predictor cases.
        Prefill_Fields?.filter((obj) => {
          if(window.location.href?.includes(obj.url) && (signupUrl || completeProfileUrl)){
           if(data?.[0]?.options?.[0] && !cookies.get("common_embbed_fields")?.formValues?.location){
            props.setFormikValues((prev) => ({ ...prev, "location":  data?.[0]?.options?.[0]}));
        }}
      })
      if (pageNumber == 1) {
        setLocationList(data);
      } else {
        if (locationList[locationList?.length - 1]?.label == data[0]?.label) {
          let array = [];
          let obj = {};
          array.push(locationList[locationList?.length - 1]?.options);
          array.push(data[0]?.options);
          obj.label = locationList[locationList?.length - 1]?.label;
          obj.options = array?.flat();
          let array2 = [...locationList];
          array2[array2?.length - 1] = obj;
          setLocationList(array2);
        } else {
          setLocationList((prev) => [...prev, ...data]);
        }
      }
    }
  }, [data]);

  useEffect(() => {
    if (pageNumber > 1) {
      let params = {};
      params.current_url = sourseDestination || createCurrentUrl();
      params.current_location = props.geolocationData?.city ? `${props.geolocationData?.city},${props.geolocationData?.state},${props.geolocationData?.country}` : "";
      params.field = "location";
      params.q = searchQuery;
      params.page_size = 20;
      params.page_number = pageNumber;
      params.certification = props.domain?.id == 2 ? "True" : "False";
      props.dispatch(getLocationField(params));
    }
  }, [pageNumber]);

  useEffect(() => {
    setLoading(props.locationFieldLoading);
  }, [props.locationFieldLoading]);

  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && data) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const handleFocus = () => {
    props.updateTouchedFields({ ...touched, [`${name}`]: true });
    setSearchQuery("");
    setPageNumber(1);
    if(deviceType == "mobile") getLocaltionFieldApi();
  };
  const handleOpenLoaction = () => {
    setShow(true);
    props.updateTouchedFields({ ...touched, [`${name}`]: true });
  };
  const handleCloseLoaction = () => {
    setLocationList([]);
    setShow(false);
    setSearchQuery("");
    props.updateTouchedFields({ ...touched, [`${name}`]: true });
    setPageNumber(1);

  };
  const handleDropdownSelect = (option) => {
    setShowDropdown(false);
    const selectedOption = locationList
      ?.flatMap((group) => group?.options)
      ?.find((item) => item?.label === option);

    setFieldValue("location", selectedOption);
    {signupUrl &&
    props.setSyncSignupValues((prev) => ({ ...prev, "location": selectedOption }))}
    if(completeProfileUrl){
      props.signupDataPost("save", null, null, null, selectedOption); 
     }
    return selectedOption;
  };

  const handleDropdownClick = (e) => {
    const clickedOption = e.target?.getAttribute("data-label");
    if (clickedOption) {
      handleDropdownSelect(clickedOption);
      setShow(false);
      setPageNumber(1);
    }
  };

  const handleCurrentLocationClick = () => {
    setLocationList([]);
    if (data?.length > 0) {
      const currentLocation = data[0]?.options[0];
      setFieldValue("location", currentLocation);
      {signupUrl && 
        props.setSyncSignupValues((prev) => ({ ...prev, "location": currentLocation }))}
        if(completeProfileUrl){
          props.signupDataPost("save", null, null, null, currentLocation); 
         }
      setShowDropdown(false);
      setShow(false);

    }
  };
  const handleLocationSearch = (e) => {
    setSearchQuery(e.target.value);
    setPageNumber(1);
    setData([]);
    setLocationList([]);
    if (e.target?.value?.length >= 0) {
      let inDebounce = debounceState;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => {
        if (e.target?.value?.length >= 0) {
          setSearchQuery(e.target.value);
          let params = {};
          params.current_url = sourseDestination || createCurrentUrl();
          params.current_location = props.geolocationData?.city ? `${props.geolocationData?.city},${props.geolocationData?.state},${props.geolocationData?.country}` : "";
          params.field = "location";
          params.q = e.target.value;
          // params.city_limit = 100
          // params.state_limit = 10
          // params.page_number = 1;
          props.dispatch(getLocationField(params));
        }
      }, 500);
      setDebounceState(inDebounce);
    }
  };

  // This useEffect is for key navigations
  useEffect(() => {
    const locationInputField = document?.getElementById("location_filed");
    const input = document?.getElementById("locationSearchInput");
    const dropdown = document?.getElementById("locationDropdown");
    let focusedOptionIndex = focussedOption;
    if (input && dropdown) {
      input?.addEventListener("focus", () => {
        dropdown.style.display = "block";
      });
      input?.addEventListener("blur", () => {
        dropdown.style.display = "block";
      });
      input?.addEventListener("keydown", (event) => {
        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
          event.preventDefault();
          const options = dropdown.querySelectorAll("div.option");
          if (event.key === "ArrowUp") {
            focusedOptionIndex = Math.max(focusedOptionIndex - 1, 0);
            options[focusedOptionIndex]?.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
            });
          } else if (event.key === "ArrowDown") {
            focusedOptionIndex = Math.min(
              focusedOptionIndex + 1,
              options.length - 1
            );
            options[focusedOptionIndex]?.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
            });
          }
          options.forEach((option) => option.classList.remove("focused"));
          options[focusedOptionIndex]?.classList.add("focused");
          setFocussedOption(focusedOptionIndex)
        } else if (event.key === "Enter") {
          event.preventDefault();
          if (focusedOptionIndex !== -1) {
            locationInputField.value = dropdown
              .querySelectorAll("div.option")
            [focusedOptionIndex]?.textContent;
            setSearchQuery("");
            handleDropdownSelect(dropdown.querySelectorAll("div.option")[focusedOptionIndex]?.textContent);
            handleDropdownClick(dropdown.querySelectorAll("div.option")[focusedOptionIndex]?.textContent);
          }
          dropdown.style.display = "block";
          setShowDropdown(false);
        }
      });
    }
  }, [locationList]);


  return (
    <div className="registration_location_cover">
      {deviceType == "web" ? (
        <div
          className="careers_register_form_card_location_cover"
          ref={dropdownRef}
        >
          <div
            className={
              errors[name] && touched[name] && !showDropdown
                ? "careers_register_form_card invalid_field"
                : values[name]
                  ? "careers_register_form_card white_bg"
                  : "careers_register_form_card"
            }
          >
            <input
              type="text"
              name="location"
              id="location_filed"
              className="input_type_text"
              placeholder={focused ? "Select" : ""}
              onFocus={() => {
                handleFocus();
                setFocused(true);
              }}
              value={values?.location?.label}
              onChange={(e) => {
                setFieldValue("location", e.target.value);
                signupUrl && props.setSyncSignupValues((prev) => ({ ...prev, "location": e.target.value }))
                if(completeProfileUrl){
                  props.signupDataPost("save", null, null, null, e.target.value); 
                }
              }}
              onClick={() => {setShowDropdown(!showDropdown), setFocussedOption(-1)}}
              autoComplete="off"
              readOnly
            />
            <span
              className={
                focused || searchQuery || values?.location
                  ? "floating_label_active"
                  : "floating_label"
              }
            >
              City You Live In
            </span>
            {/* {!errors.location && values?.location?.id && <img src={validIcon} alt="careers_register_checkIcon" className='careers_register_valid_icon' />} */}
            {errors.location && touched?.location && !showDropdown && (
              <div className="invalid_card">
                <span className="invalid_card_text">{errors.location}</span>
              </div>
            )}
          </div>
          {showDropdown && (
            <>
              <div
                className="location_dropdown"
                onClick={(e) => handleDropdownClick(e)}
              >
                <div className="location_search">
                  <input
                    className="country_code_search location_search_field"
                    type="text"
                    name="location"
                    placeholder={"Search..."}
                    onBlur={() => {
                      setFocused(false);
                      handleBlur({
                        target: { name: "location" },
                      });
                      setSearchQuery("");
                    }}
                    onFocus={() => {
                      handleFocus();
                      setFocused(true);
                    }}
                    value={searchQuery}
                    onChange={(e) => {
                      handleLocationSearch(e);
                    }}
                    onClick={() => setShowDropdown(true)}
                    autoComplete="off"
                    autoFocus
                    id="locationSearchInput"
                  />
                </div>
                <div className="location_options_dropdown" id="locationDropdown">
                  {locationList?.length == 0 &&
                    Object?.keys(props.locationFieldData?.values?.locations || {})
                      ?.length ? (
                    <Loading />
                  ) : locationList?.length > 0 ? (
                    locationList?.map((group) => (
                      <div className="group" key={group.label}>
                        {group.label === "default_location" ? (
                          <span
                            className="default_location"
                            onClick={handleCurrentLocationClick}
                          >
                            <BiCurrentLocation />
                            <span className="default_location_text">My current location</span>
                          </span>
                        ) : (
                          group?.options.length > 0 && (
                            <div className="dropdown_group_heading">
                              {group.label === "popular_cities"
                                ? "Popular Cities"
                                : `${group.label}`}
                            </div>
                          )
                        )}
                        {group?.label != "default_location" &&
                          group.options?.map((option, index) => {
                            return (
                              <div
                                key={`${option.label}-${option.id}-${index}`}
                                className={`option${selectedOption == option.label ? "selected" : ""
                                  }`}
                                data-label={option.label}
                                onClick={() => handleDropdownClick(option)}
                              >
                                <span
                                  ref={lastBookElementRef}
                                  data-label={option.label}
                                >
                                  {option.label}
                                </span>
                              </div>
                            );
                          })}
                      </div>
                    ))
                  ) : (
                    <div className="no_options_found">No options found</div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        <>
          <div className="careers_register_form_card_location_cover">
            <div
              className={
                errors[name] && touched[name]
                  ? "careers_register_form_card invalid_field"
                  : values[name]
                    ? "careers_register_form_card white_bg"
                    : "careers_register_form_card"
              }
              onClick={handleOpenLoaction}
            >
             <div
                type="text"
                name="location"
                className="input_type_text custom_location_input"
                onClick={handleOpenLoaction}
               >{values?.location?.label?.split(",")?.join(", ")}</div>
              <span
                className={
                  values?.location ? "floating_label_active" : "floating_label"
                }
              >
                City You Live In
              </span>
            </div>
            {/* {!errors.location && values?.location?.id && <img src={validIcon} alt="careers_register_checkIcon" className='careers_register_valid_icon' />} */}
            {errors.location && touched?.location && (
              <div className="invalid_card">
                <span className="invalid_card_text">{errors.location}</span>
              </div>
            )}
          </div>
          <CommonModal
            isOpen={show}
            closeModal={() => handleCloseLoaction()}
            classNames={{
              root: "location_mobile_modal",
              modal: "custom_modal",
              modalAnimationIn: "customEnterModalAnimation",
              modalAnimationOut: "customLeaveModalAnimation",
            }}
            animationDuration={800}
          >
            <div className="careers_register_form_card_location_cover inner_modal location_field">
              <h4>City You Live In</h4>
              <div
                className={
                  values[name]
                    ? "careers_register_form_card  white_bg"
                    : " careers_register_form_card location_search_mobile "
                }
              >
                <input
                  type="text"
                  name="location"
                  className="input_type_text"
                  onBlur={handleBlur}
                  placeholder="Search..."
                  onFocus={() => {
                    handleFocus()}}
                  // value={values?.location?.label?.split(",")?.join(", ")}
                  onChange={(e) => {
                    // setFieldValue("location", e.target.value);
                    signupUrl && props.setSyncSignupValues((prev) => ({ ...prev, "location": e.target.value }))
                    if(completeProfileUrl){
                      props.signupDataPost("save", null, null, null, e.target.value); 
                     }
                    handleLocationSearch(e);
                  }}
                  autoFocus={false}
                  // onClick={() => {
                  //   setReadOnly(false)
                  // }}
                  // readOnly={read}
                />
              </div>

             <div
                className="location_dropdown"
                onClick={(e) => handleDropdownClick(e)}
                ref={dropdownRef}
              >
                {locationList.length == 0 &&
                  Object?.keys(props.locationFieldData?.values?.locations || {})
                    ?.length ? (
                  <Loading />
                ) : locationList?.length > 0 ? (
                  locationList?.map((group) => (
                    <div className="group" key={group.label}>
                      {group?.label === "default_location" ? (
                        <span
                          className="default_location"
                          onClick={handleCurrentLocationClick}
                        >
                          <BiCurrentLocation />
                          <span className="default_location_text">My current location</span>
                        </span>
                      ) : (
                        group?.options.length > 0 && (
                          <div className="dropdown_group_heading">
                            {group.label === "popular_cities"
                              ? "Popular Cities"
                              : `${group.label}`}
                          </div>
                        )
                      )}
                      {group?.label != "default_location" &&
                        group.options?.map((option, index) => (
                          <div
                            key={`${option.label}-${option.id}-${index}`}
                            className={`option ${selectedOption === option.label ? "selected" : ""
                              }`}
                            data-label={option.label}
                          >
                            <span
                              data-label={option.label}
                              onClick={() => handleDropdownClick(option)}
                              ref={lastBookElementRef}
                            >
                              {option.label}
                            </span>
                          </div>
                        ))}
                    </div>
                  ))
                ) : (
                  <div className="no_options_found">No options found</div>
                )}
              </div>
            </div>
          </CommonModal>
        </>
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    locationFieldLoading: state.userSignUpFields?.locationFieldLoading,
    ipinfoLocationData: state.userSignUpFields?.ipinfoLocation,
    locationFieldData: state.userSignUpFields?.locationField,
    geolocationData: state.usersCommonData?.geoLocation,
    locationFieldLoading: state.usersCommonData?.locationFieldLoading,
    userIps: state.usersCommonData?.userIp,
    locationFieldError: state.usersCommonData?.locationFieldError
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CareersRegisterInputLocation);
